module.exports = __webpack_public_path__ + "img/fixed_broken_toilet.ff566924.svg";